import NotFound from "@standard/pages/NotFound";

export default NotFound;
